<template>
  <div id="register">
    <div class="contentBox">
      <div class="leftImg">
        <div style="position: absolute;left: 80px;top: 50px">
          <img src="../assets/img/logo.png" alt="">
          <span style="font-size: 20px;color: #FFFFFF;vertical-align: middle">通用仿真软件</span>
        </div>
        <div class="imgArea" style="width: 100%;height: 100%">

        </div>
      </div>
      <div class="rightContent">
        <div>
          <span class="returnIndex" style="cursor: pointer" title="返回主页" @click="$router.push('/')">
          <Icon type="md-home" size="20"/>
        </span>
          <div class="title" >注册</div>

          <div class="userInfo">
            <div style="margin-bottom: 16px; display: flex; align-items: center;">
              <span class="inputlabel">用户名：</span>
              <div style="width: 360px;">
                <Input v-model="regisData.username" style="width: 100%" @on-blur="usernameCheck"
                       @on-input="usernameCheck"/>
              </div>
              <!-- 验证通过时显示成功标识 -->
              <div v-if="regisData.username.length > 0 && regisData.usernameValid" class="validation-container">
                <span class="validation-icon valid">✓</span>
              </div>
              <!-- 验证失败时显示详细规则 -->
              <div v-else-if="regisData.username.length > 0 && regisData.usernameValid === false"
                   class="validation-container">
                <div class="floating-error-right">
                  <div class="rule-item"
                       :class="{ 'pass': regisData.username.length >= 4 && regisData.username.length <= 16 }">
                  <span class="rule-icon">{{
                      regisData.username.length >= 4 && regisData.username.length <= 16 ? '✓' : '✗'
                    }}</span>
                    <span>长度在4-16字符之间</span>
                  </div>
                  <div class="rule-item" :class="{ 'pass': /^[\u4e00-\u9fa5a-zA-Z0-9_]+$/.test(regisData.username) }">
                  <span class="rule-icon">{{
                      /^[\u4e00-\u9fa5a-zA-Z0-9_]+$/.test(regisData.username) ? '✓' : '✗'
                    }}</span>
                    <span>只能包含中文、字母、数字和下划线</span>
                  </div>
                  <div v-if="regisData.usernameError" class="rule-item error">
                    <span class="rule-icon">✗</span>
                    <span>{{ regisData.usernameError }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 16px; display: flex; align-items: center;">
              <span class="inputlabel">密码：</span>
              <div style="width: 360px;">
                <Input v-model="regisData.password" :type="inputType" style="width: 100%" @on-blur="psdCheck"
                       @on-input="psdCheck"/>
              </div>
              <span @click="changeInputType" style="position: relative;right: 22px;cursor: pointer">
              <img v-if="inputType==='password'" src="../assets/img/eye.png" alt="">
              <img v-if="inputType==='text'" src="../assets/img/hideeye.png" alt="">
            </span>
              <!-- 验证通过时显示成功标识 -->
              <div v-if="regisData.password.length > 0 && regisData.passwordValid" class="validation-container">
                <span class="validation-icon valid">✓</span>
              </div>
              <!-- 验证失败时显示详细规则，但当用户名也验证失败时不显示 -->
              <div
                v-else-if="regisData.password.length > 0 && regisData.passwordValid === false && !(regisData.username.length > 0 && regisData.usernameValid === false)"
                class="validation-container">
                <div class="floating-error-right">
                  <div class="rule-item"
                       :class="{ 'pass': regisData.password.length >= 8 && regisData.password.length <= 16 }">
                  <span class="rule-icon">{{
                      regisData.password.length >= 8 && regisData.password.length <= 16 ? '✓' : '✗'
                    }}</span>
                    <span>长度在8-16字符之间</span>
                  </div>
                  <div class="rule-item" :class="{ 'pass': /\d/.test(regisData.password) }">
                    <span class="rule-icon">{{ /\d/.test(regisData.password) ? '✓' : '✗' }}</span>
                    <span>必须包含数字</span>
                  </div>
                  <div class="rule-item" :class="{ 'pass': /[a-zA-Z]/.test(regisData.password) }">
                    <span class="rule-icon">{{ /[a-zA-Z]/.test(regisData.password) ? '✓' : '✗' }}</span>
                    <span>必须包含字母</span>
                  </div>
                </div>
              </div>
            </div>
            <!--          <div style="margin-bottom: 10px">-->
            <!--            <span class="inputlabel" style="text-align: right;margin-top: 5px">用户名：</span>-->
            <!--            <Input v-model="trialUser.username" disabled style="width: 360px"/>-->
            <!--          </div>-->
            <div style="margin-bottom: 16px; display: flex; align-items: center;">
              <span class="inputlabel">确认密码：</span>
              <div style="width: 360px;">
                <Input v-model="regisData.checkpassword" :type="inputType" style="width: 100%" @on-blur="twicepsdCheck"
                       @on-input="twicepsdCheck"/>
              </div>
              <span @click="changeInputType" style="position: relative;right: 22px;cursor: pointer">
              <img v-if="inputType==='password'" src="../assets/img/eye.png" alt="">
              <img v-if="inputType==='text'" src="../assets/img/hideeye.png" alt="">
            </span>
              <!-- 验证通过时显示成功标识 -->
              <div v-if="regisData.checkpassword.length > 0 && regisData.confirmPasswordValid"
                   class="validation-container">
                <span class="validation-icon valid">✓</span>
              </div>
              <!-- 验证失败时显示详细规则 -->
              <div v-else-if="regisData.checkpassword.length > 0 && regisData.confirmPasswordValid === false"
                   class="validation-container">
                <div class="floating-error-right">
                  <div class="rule-item error">
                    <span class="rule-icon">✗</span>
                    <span>{{ regisData.confirmPasswordError }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 16px; display: flex; align-items: center;">
              <span class="inputlabel">用户昵称：</span>
              <div style="width: 360px;">
                <Input v-model="trialUser.nickname" style="width: 100%"/>
              </div>
            </div>
            <div style="margin-bottom: 16px; display: flex; align-items: center;">
              <span class="inputlabel"><span style="color: red">*</span>手机号：</span>
              <div style="width: 360px;">
                <Input v-model="trialUser.mobilephone" style="width: 100%" @on-blur="mobilephoneCheck"
                       @on-input="mobilephoneCheck"/>
              </div>
              <!-- 验证通过时显示成功标识 -->
              <div v-if="trialUser.mobilephone.length > 0 && trialUserValid.mobilephoneValid"
                   class="validation-container">
                <span class="validation-icon valid">✓</span>
              </div>
              <!-- 验证失败时显示详细规则 -->
              <div v-else-if="trialUser.mobilephone.length > 0 && trialUserValid.mobilephoneValid === false"
                   class="validation-container">
                <div class="floating-error-right">
                  <div class="rule-item error">
                    <span class="rule-icon">✗</span>
                    <span>{{ trialUserValid.mobilephoneError }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 16px; display: flex; align-items: center;">
              <span class="inputlabel"><span style="color: red">*</span>邮箱：</span>
              <div style="width: 360px;">
                <Input v-model="trialUser.email" style="width: 100%" @on-blur="emailCheck" @on-input="emailCheck"/>
              </div>
              <!-- 验证通过时显示成功标识 -->
              <div v-if="trialUser.email.length > 0 && trialUserValid.emailValid" class="validation-container">
                <span class="validation-icon valid">✓</span>
              </div>
              <!-- 验证失败时显示详细规则 -->
              <div v-else-if="trialUser.email.length > 0 && trialUserValid.emailValid === false"
                   class="validation-container">
                <div class="floating-error-right">
                  <div class="rule-item error">
                    <span class="rule-icon">✗</span>
                    <span>{{ trialUserValid.emailError }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 16px; display: flex; align-items: center;">
              <span class="inputlabel"><span style="color: red">*</span>工作单位：</span>
              <div style="width: 360px;">
                <Input v-model="trialUser.company" style="width: 100%" @on-blur="companyCheck"
                       @on-input="companyCheck"/>
              </div>
              <!-- 验证通过时显示成功标识 -->
              <div v-if="trialUser.company.length > 0 && trialUserValid.companyValid" class="validation-container">
                <span class="validation-icon valid">✓</span>
              </div>
              <!-- 验证失败时显示详细规则 -->
              <div v-else-if="trialUser.company.length > 0 && trialUserValid.companyValid === false"
                   class="validation-container">
                <div class="floating-error-right">
                  <div class="rule-item error">
                    <span class="rule-icon">✗</span>
                    <span>{{ trialUserValid.companyError }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 16px; display: flex; align-items: center;">
              <span class="inputlabel">所在城市：</span>
              <div style="width: 360px;">
                <Input v-model="trialUser.address" style="width: 100%"/>
              </div>
            </div>

            <div style="margin-bottom: 16px; display: flex; align-items: center;">
              <span class="inputlabel">验证码：</span>
              <div style="width: 170px;">
                <Input v-model="regisData.captcha" style="width: 100%"/>
              </div>
              <img @click="changeCap" :src=captchaURL alt="" class="yzm"
                   style="width: 170px;border-radius: 4px;border: 1px solid #DCDFE6;height: 32px;margin-left: 20px">
            </div>

<!--            <div style="margin-bottom: 10px; display: flex; align-items: center;">-->
<!--              <span class="inputlabel">试用授权：</span>-->
<!--              <div style="width: 360px;">-->
<!--                <Select v-model="trialUser.clientType" style="width:100%">-->
<!--                  <Option v-for="item in clientTypes" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
<!--                </Select>-->
<!--              </div>-->
<!--            </div>-->
            <div style="padding-left: 108px;font-size: 14px;color: #666666;">
<!--              注：普通版，教育版到期后自动转为限制版-->
              注：试用授权时限为1个月
            </div>
            <div style="margin-top: 16px;margin-left: 108px">
              <div class="button1" @click="register">
                注册
              </div>
              <div class="button2" @click="jump">
                登录
              </div>

            </div>
            <div style="margin-top: 40px;padding-left: 80px">
              <img src="../assets/img/phone.png" alt="">
              <span style="text-align: right;margin-left: 2px">咨询热线：</span>
              <span style="display: inline-block;">400-8000-900</span>
              <img src="../assets/img/email.png" alt="" style="margin-left: 60px">
              <span style="text-align: right;margin-left: 2px">联系邮箱：</span>
              <span style="display: inline-block;">cae@cabrtech.com</span>
            </div>

          </div>
        </div>


      </div>
    </div>
  </div>

</template>

<script>
import {checkUsername, register, captcha, trial} from '../api/index'

export default {
  name: "register",
  data() {
    return {
      inputType: 'password',
      regisData: {
        username: '',
        password: '',
        checkpassword: '',
        captcha: '',

        usernameAvailable: false,
        usernameValid: null, // null: 未验证, true: 验证通过, false: 验证失败
        passwordValid: null,  // null: 未验证, true: 验证通过, false: 验证失败
        confirmPasswordValid: null,  // null: 未验证, true: 验证通过, false: 验证失败
        usernameError: '',    // 用户名错误信息
        confirmPasswordError: ''     // 确认密码错误信息

      },
      trialUser: {
        username: '',
        nickname: '',
        mobilephone: '',
        email: '',
        company: '',
        address: '',
        clientType: 1,
      },
      trialUserValid: {
        mobilephoneValid: null, // null: 未验证, true: 验证通过, false: 验证失败
        emailValid: null,
        companyValid: null,
        mobilephoneError: '',
        emailError: '',
        companyError: ''
      },
      clientTypes: [
        {value: -1, label: '限制版-无期限'},
        {value: 1, label: '普通版-1个月'},
        {value: 2, label: '教育版-3个月'}
      ],
      roles: [
        "cae_user",
        "client_user"
      ],
      // 地址修改
      captchaURL: captcha + "?_=" + Math.floor(Math.random() * 100),
    }
  },
  mounted() {
    // 检查浏览器自动填充的值并触发验证
    // 使用setTimeout确保浏览器有足够时间完成自动填充
    setTimeout(() => {
      if (this.regisData.username) {
        this.usernameCheck();
      }
      if (this.regisData.password) {
        this.psdCheck();
      }
      if (this.regisData.checkpassword) {
        this.twicepsdCheck();
      }
      if (this.trialUser.mobilephone) {
        this.mobilephoneCheck();
      }
      if (this.trialUser.email) {
        this.emailCheck();
      }
      if (this.trialUser.company) {
        this.companyCheck();
      }
    }, 300); // 增加延迟时间，确保浏览器有足够时间完成自动填充

    // 监听密码字段的变化，包括自动填充
    const passwordInputs = document.querySelectorAll('input[type="password"]');
    passwordInputs.forEach(input => {
      // 监听input事件
      input.addEventListener('input', () => {
        this.psdCheck();
        this.twicepsdCheck();
      });
      // 监听change事件
      input.addEventListener('change', () => {
        this.psdCheck();
        this.twicepsdCheck();
      });
      // 监听blur事件
      input.addEventListener('blur', () => {
        this.psdCheck();
        this.twicepsdCheck();
      });
    });
  },
  methods: {
    changeInputType() {
      if (this.inputType === 'text') {
        this.inputType = 'password'
      } else {
        this.inputType = 'text'
      }

    },
    changeCap() {
      // 地址修改
      this.captchaURL = captcha + "?_=" + Math.floor(Math.random() * 100)
    },

    usernameCheck() {
      // 重置错误信息
      this.regisData.usernameError = '';

      // 检查长度是否在4-16字符之间
      if (this.regisData.username.length < 4 || this.regisData.username.length > 16) {
        this.regisData.usernameValid = false;
        return;
      }
      // 检查用户名格式是否只包含中文、大小写字母、数字和下划线
      const usernameRegex = /^[\u4e00-\u9fa5a-zA-Z0-9_]+$/;
      if (!usernameRegex.test(this.regisData.username)) {
        this.regisData.usernameValid = false;
        return;
      }
      // 调用后端API检查用户名是否可用
      let obj = {
        username: this.regisData.username
      }

      checkUsername(obj).then((res) => {
        let resData = res.data
        if (resData.result.success == true) {
          this.regisData.usernameAvailable = true
          this.regisData.usernameValid = true;
          this.regisData.usernameError = '';
        } else {
          this.regisData.usernameAvailable = false;
          this.regisData.usernameValid = false;
          this.regisData.usernameError = resData.result.info;
        }
      }).catch((error) => {
        console.log(error);
        this.regisData.usernameValid = false;
        this.regisData.usernameError = '用户名检查失败，请稍后重试';
      })
    },

    psdCheck() {
      let reg = /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{8,16}$/;

      if (reg.test(this.regisData.password) == false) {
        this.regisData.passwordValid = false;
      } else {
        this.regisData.passwordValid = true;
      }
    },

    twicepsdCheck() {
      this.regisData.confirmPasswordError = '';

      if (this.regisData.password !== this.regisData.checkpassword) {
        this.regisData.confirmPasswordError = '两次输入的密码不一致';
        this.regisData.confirmPasswordValid = false;
      } else if (this.regisData.checkpassword.length === 0) {
        this.regisData.confirmPasswordValid = null;
      } else {
        this.regisData.confirmPasswordValid = true;
      }

    },

    mobilephoneCheck() {
      // 重置错误信息
      this.trialUserValid.mobilephoneError = '';

      let reg = /^1\d{10}$/;
      if (!reg.test(this.trialUser.mobilephone)) {
        this.trialUserValid.mobilephoneError = '手机号格式错误!';
        this.trialUserValid.mobilephoneValid = false;
      } else {
        this.trialUserValid.mobilephoneValid = true;
        this.trialUserValid.mobilephoneError = '';
      }
    },

    emailCheck() {
      // 重置错误信息
      this.trialUserValid.emailError = '';

      if (!this.trialUser.email) {
        this.trialUserValid.emailError = '邮箱信息不能为空!';
        this.trialUserValid.emailValid = false;
      } else {
        // 简单的邮箱格式验证
        let reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!reg.test(this.trialUser.email)) {
          this.trialUserValid.emailError = '邮箱格式错误!';
          this.trialUserValid.emailValid = false;
        } else {
          this.trialUserValid.emailValid = true;
          this.trialUserValid.emailError = '';
        }
      }
    },

    companyCheck() {
      // 重置错误信息
      this.trialUserValid.companyError = '';

      if (!this.trialUser.company) {
        this.trialUserValid.companyError = '工作单位信息不能为空!';
        this.trialUserValid.companyValid = false;
      } else {
        this.trialUserValid.companyValid = true;
        this.trialUserValid.companyError = '';
      }
    },

    register() {
      // 触发所有验证
      this.mobilephoneCheck();
      this.emailCheck();
      this.companyCheck();

      // 检查所有必填字段是否验证通过
      if (this.trialUserValid.mobilephoneValid !== true ||
        this.trialUserValid.emailValid !== true ||
        this.trialUserValid.companyValid !== true) {
        this.$Message.error('请检查必填字段');
        return;
      }

      if (!this.regisData.captcha) {
        this.$Message.error('请输入验证码');
        return;
      }

      if (this.regisData.usernameAvailable == true) {
        let obj = {
          username: this.regisData.username,
          password: this.regisData.password,
          captcha: this.regisData.captcha
        }
        register({roles: this.roles.join(","), ...this.trialUser, ...obj}).then((res) => {
          let resData = res.data
          if (resData.result.success == true) {
            this.trialUser.username = this.regisData.username
            this.$Message.success({content: "注册并申请授权成功，请重新进行登录！", duration: 5});
            // this.$Message.success("注册成功，请返回登录页进行登录");
            // this.submitTrial()
            this.regisData.username = ''
            this.regisData.password = ''
            this.regisData.captcha = ''
            this.changeCap()
            this.$router.push("login")
          } else {
            this.$Message.error(resData.result.info);
            this.changeCap()
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.$Message.error('注册失败，请检查用户名和密码');
        this.changeCap()
      }

    },
    submitTrial() {

      return trial({roles: this.roles.join(","), ...this.trialUser}).then((res) => {
        if (res.data.result.success) {
          // this.$Message.success("申请PKPM-CAE桌面端试用授权成功!");
          this.$Message.success({content: "注册并申请授权成功，请重新进行登录！", duration: 5});
          this.$router.push("login")
          // this.showTrialModal = false;
        } else {
          this.$Message.error(res.data.result.info);
        }
      }).catch((e) => {
        console.log(e);
        this.$Message.error("申请授权失败!");
      })

    },

    jump() {
      this.$router.push("login")
    }
  }
}
</script>

<style scoped lang="scss">
#register {
  background-color: #4871E1;
  overflow: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.contentBox {
  display: flex;
  width: 100%;
  height: 100%;
  background: #FFFFFF;


  .leftImg {
    width: 57%;
    display: inline-block;
    .imgArea{
      background: url("../../static/img/userLeft.png")no-repeat;
      background-size: cover;
    }
  }

  .rightContent {
    display: flex;
    width: 43%;
    justify-content: center;
    align-items: center;

    .title {
      width: 100%;
      font-weight: 500;
      text-align: center;
      font-size: 30px;
      color: #333333;

    }

    .inputBox {
      display: inline-block;
      background: #FFFFFF;
      border: 1px solid #DCDCDC;
      border-radius: 25px;
      width: 340px;
      height: 50px;
      margin-bottom: 20px;
      padding: 15px 30px;
      text-align: left;

      .icons {
        width: 22px;
      }

      .inputkuang {
        margin-left: 15px;
        height: 20px;
        width: 235px;
        border: none;
        outline: none;

        &:focus {
          border: none;
        }
      }

      .yzm {
        float: right;
        top: -7px;
        right: -13px;
        position: relative;
        width: 80px;
        height: 30px;
      }
    }

    .forgetPwd {
      display: inline-block;
      font-size: 14px;
      color: #666666;
      width: 340px;
      padding: 0 20px;
      text-align: right;
    }

    .getMes {
      cursor: pointer;
      font-size: 14px;
      color: #2651BB;
      text-align: right;
      display: inline-block;
      width: 56px;
      height: 20px;
    }

    .buttons {
      margin-top: 5px;
      display: inline-block;
      width: 340px;

      .buttonR {
        cursor: pointer;
        display: inline-block;
        background: #E5E7ED;
        border-radius: 25px;
        width: 160px;
        height: 50px;
        font-size: 16px;
        color: #5E677D;
        text-align: center;
        padding: 15px;
      }

      .buttonL {
        cursor: pointer;
        display: inline-block;
        background: #2651BB;
        border-radius: 25px;
        width: 160px;
        height: 50px;
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
        padding: 15px;
      }
    }

    .tips {
      //margin-bottom: 10px;
      padding-left: 30px;
      width: 340px;
      display: inline-block;
      text-align: left;
      font-size: 12px;
      color: #666666;
      position: relative;
    }

    .validation-container {
      position: relative;
      margin-left: 8px;
      display: inline-flex;
      align-items: center;
      vertical-align: middle;
      white-space: nowrap;
    }

    /* 调整悬浮窗位置，确保没有单个标识时也能正确显示 */
    .validation-container .floating-error-right {
      left: 8px;
    }

    .validation-icon {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      text-align: center;
      line-height: 12px;
      font-size: 10px;
      margin-right: 4px;
      vertical-align: middle;
    }

    .validation-icon.valid {
      background-color: #52c41a;
      color: white;
    }

    .validation-icon.invalid {
      background-color: #ff4d4f;
      color: white;
    }

    .floating-error-right {
      position: absolute;
      left: 100%;
      top: 50%;
      transform: translateY(-50%);
      margin-left: 10px;
      padding: 10px;
      background-color: #fff1f0;
      border: 1px solid #ffccc7;
      border-radius: 4px;
      color: #ff4d4f;
      font-size: 12px;
      line-height: 1.6;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      z-index: 20;
      min-width: 200px;
    }

    .floating-error-right::before {
      content: '';
      position: absolute;
      top: 50%;
      left: -5px;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      border-right: 5px solid #ffccc7;
    }

    .floating-error-right::after {
      content: '';
      position: absolute;
      top: 50%;
      left: -4px;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      border-right: 5px solid #fff1f0;
    }

    .rule-item {
      display: flex;
      align-items: center;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .rule-icon {
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      text-align: center;
      line-height: 14px;
      font-size: 10px;
      margin-right: 8px;
      background-color: #ff4d4f;
      color: white;
    }

    .rule-item.pass .rule-icon {
      background-color: #52c41a;
    }

    .rule-item.error {
      color: #ff4d4f;
      font-weight: 500;
    }
  }
}

.returnIndex {
  position: absolute;
  display: inline-block;
  right: 15px;
  float: right;
  top: 15px;
}

.userInfo {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-content: center;
  flex-wrap: wrap;
  justify-content: center;

  .inputlabel {
    display: inline-block;
    width: 100px;
    text-align: right;
    margin-right: 10px;
    vertical-align: middle;
  }
}

.button1 {
  width: 360px;
  height: 40px;
  background: #0069E0;
  border-radius: 4px;
  line-height: 40px;
  text-align: center;
  color: white;
  cursor: pointer;
  font-size: 18px;
}

.button2 {
  width: 360px;
  height: 40px;
  border: 1px solid #0069E0;
  border-radius: 4px;
  line-height: 40px;
  text-align: center;
  color: #0069E0;
  margin-top: 16px;
  cursor: pointer;
  font-size: 18px;
}

</style>



// WEBPACK FOOTER //
// src/components/register.vue